// wait for the DOM to be loaded
document.addEventListener("DOMContentLoaded", function () {
  let productPage = document.querySelector(".body-template-product");

  if (!productPage) {
    // console.log("Product page not found");
    return;
  }
  // console.log("Product page found");
  let zippyContainer = document.querySelector("#CartDrawer");
  let toAddcartButton = document.querySelector(".product-form__buttons-row");

  // add hover effect to the add to cart button
  toAddcartButton.addEventListener("mouseover", function () {
    let isDrawer = document.querySelectorAll(".cart-item");
    // console.log(isDrawer);

    let errorDiv = document.querySelector(".error-duplicate");
    if (errorDiv && !toAddcartButton.classList.contains("difference")) {
      errorDiv.remove();
      toAddcartButton.classList.remove("disable");
    }

    if (toAddcartButton.classList.contains("disable") && !toAddcartButton.classList.contains("difference")) {
      toAddcartButton.classList.remove("disable");
    }
  });

  let isClicked = false;

  toAddcartButton.addEventListener("click", function () {
    isClicked = true;
  });

  if (zippyContainer) {
    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          setTimeout(() => {
            let drawerwrapper = document.querySelector(".drawer__cart-items-wrapper");

            if (!drawerwrapper) {
              // console.log("Drawer not found");

              let errorDiv = document.querySelector(".error-duplicate");
              if (errorDiv) {
                errorDiv.remove();
              }

              let ispostcode = document.querySelector("#delivery-attribute-date");

              if (ispostcode.value != "") {
                toAddcartButton.classList.remove("disable");
                toAddcartButton.classList.remove("difference");
                toAddcartButton.classList.remove("not-allowed");
              }
            
              let drawerItems = drawerwrapper.querySelectorAll(".cart-item");

              if (drawerItems.length < 2) {
                return;
              }

              // find the duplicate items
              let selectedBoxes = [];

              drawerItems.forEach((item) => {
                let itemOptions = item.querySelectorAll(".product-option");
                let secondItemOption = itemOptions[1].querySelector("dd").innerText;

                // Push only the box-related options
                if (secondItemOption === "1-box" || secondItemOption === "3-box") {
                  selectedBoxes.push(secondItemOption);
                }
              });

              // console.log(selectedBoxes);
              if (selectedBoxes.includes("1-box") && selectedBoxes.includes("3-box") && isClicked) {
                let removeButton = drawerwrapper.querySelector(`cart-remove-button`);
                // console.log(removeButton);
                removeButton.click();

                // find product-form__buttons-row
                let addCartButton = document.querySelector(".product-form__buttons-row");
                // create new div with class error-duplicate with text You can only purchase either 1 box or 3 boxes of Skullies
                let errorDiv = document.createElement("div");
                errorDiv.classList.add("error-duplicate");

                errorDiv.innerText = `You can only purchase one product at a time, please update your cart to change your order`;
                addCartButton.appendChild(errorDiv);

                toAddcartButton.classList.add("disable");
              } else {
                let errorDiv = document.querySelector(".error-duplicate");
                if (errorDiv) {
                  errorDiv.remove();
                }
              }
            }

            isClicked = false;
          }, 300);
        }
      });
    });

    // Start observing the target node for configured mutations
    observer.observe(zippyContainer, { childList: true, subtree: true });
  }
});
